const ɵ0 = { scope: 'toolbar' };
// export const loader = ["en", "it"].reduce((acc, lang) => {
//   acc[lang] = () => import(`../../../assets/i18n/toolbar/${lang}.json`);
//   return acc;
// },{});
export class ToolbarModule {
}
export { ɵ0 };
